/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC } from "react";
import {
  GoogleMap,
  GoogleMapProps,
  useJsApiLoader,
} from "@react-google-maps/api";
import { styled } from "@mui/material/styles";
import { SpinnerDelay } from "components/Common/SpinnerDelay";

export interface MapProps extends GoogleMapProps {}

export const Map: FC<MapProps> = ({ children, heading = 0, ...props }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLEMAP_API_KEY ?? "",
    language: "en", // only english
  });
  return (
    <MapContainer>
      {isLoaded ? (
        <GoogleMap heading={heading} tilt={0} {...props}>
          {children}
        </GoogleMap>
      ) : (
        <SpinnerDelay />
      )}
    </MapContainer>
  );
};

const MapContainer = styled("div")({
  flexGrow: 1,
  overflow: "hidden",
});
